import { useCallback, useEffect } from 'react';

import useXHR from './useXHR';

const usePut = ({ url, body, onMount, configuration }) => {
  const [state, req, , , setOriginalRequest] = useXHR(onMount, configuration);
  const requestText = JSON.stringify(body);

  const send = useCallback(
    bodyOrConfig => {
      let latestUrl = url;
      let latestBody = requestText;

      if (bodyOrConfig && !bodyOrConfig.url && !bodyOrConfig.body) {
        latestBody = JSON.stringify(bodyOrConfig);
      }

      if (bodyOrConfig?.url) {
        latestUrl = bodyOrConfig.url;
      }

      if (bodyOrConfig?.body) {
        latestBody = JSON.stringify(bodyOrConfig.body);
      }

      setOriginalRequest({
        method: 'PUT',
        url: latestUrl,
        headers: [{ key: 'Content-Type', value: 'application/json' }],
        body: latestBody,
      });
      req.open('PUT', latestUrl);
      req.setRequestHeader('Content-Type', 'application/json');
      const token = localStorage.getItem('token');
      if (token) {
        req.setRequestHeader('Authorization', `Bearer ${token}`);
      }
      req.send(latestBody);
    },
    [req, url, requestText, setOriginalRequest]
  );

  useEffect(() => {
    if (onMount) {
      send();
    }
    return () => req.abort();
  }, [onMount, send, req]);

  return [state, send];
};

export default usePut;
